import * as u from './utils';
import { debounce } from 'throttle-debounce';

export default () => {
    const container = document.querySelector('.attachment-controls');
    const menu = document.querySelector('.attachment-controls__menu');

    if (!container) {
        return false;
    }

    // Setup container to resize with the window
    const handleResize = () => {
        container.style.height = 'auto';
        container.style.height = menu.offsetHeight + 'px';
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    // Handle locking unlocking
    const handleScroll = () => {
        const windowBottom = window.innerHeight + window.pageYOffset;
        const containerBottom = container.offsetTop + container.offsetHeight;
        if (windowBottom >= containerBottom) {
            u.removeClass(menu, 'is-fixed');
        } else {
            u.addClass(menu, 'is-fixed');
        }
    };
    handleScroll();
    window.addEventListener('scroll', debounce(10, handleScroll));
    document.addEventListener('galleryfilter', handleScroll);
};
